// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.SettingsSettingsContainer[data-v-4f6ad652]\n{\n\tdisplay: inline-block;\n\tbackground-color: #f7e5ac;\n\tpadding: 10px;\n\tborder: 1px solid #721f00;\n\tborder-radius: 5px;\n\tmargin-bottom: 20px;\n}\n.propEdit[data-v-4f6ad652]\n{\n\tmargin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
